import { Response } from 'lib-shared-legacy-types';

import { ajaxSend } from 'api/api';

import type {
  AutomationCreatePayloadT,
  AutomationsGetItemsResponseT,
  AutomationsQueryParamsT,
  AutomationT,
  AutomationUpdatePayloadT,
} from './types';

const AUTOMATIONS_API_BASE_V1 = '/v1/automations';
const AUTOMATIONS_API_BASE_V2 = '/v2/automations';

class AutomationsApi {
  /**
   * Creates a automation.
   *
   * @param {AutomationCreatePayloadT} data The create automation data object.
   */
  public createAutomation(data: AutomationCreatePayloadT) {
    return ajaxSend<Response<AutomationT>>({
      data,
      method: 'POST',
      path: AUTOMATIONS_API_BASE_V1,
    });
  }

  /**
   * Gets a single automation.
   *
   * @param {string} automationId The id of the automation to be retrieved.
   */
  public getAutomation(automationId: string) {
    return ajaxSend<Response<AutomationT>>({
      path: `${AUTOMATIONS_API_BASE_V1}/${automationId}`,
    });
  }

  /**
   * Gets automations.
   *
   * @param {AutomationsQueryParamsT} [params={}] The get automations query
   *   params object. Default is `{}`
   */
  public getAutomations(params: AutomationsQueryParamsT = {}) {
    return ajaxSend<AutomationsGetItemsResponseT>({
      params: params as any,
      path: AUTOMATIONS_API_BASE_V2,
    });
  }

  /**
   * Updates automation.
   *
   * @param {string} automationId The id of the automation to be updated.
   * @param {AutomationUpdatePayloadT} payload The payload used to update the
   *   automation.
   */
  public updateAutomation(
    automationId: string,
    payload: AutomationUpdatePayloadT,
  ) {
    const { actions, active, channels, description, name } = payload;
    // data - strip automation down only updatable fields
    const data: AutomationUpdatePayloadT = {
      actions,
      active,
      channels,
      description,
      name,
    };

    return ajaxSend<Response<AutomationT>>({
      data,
      method: 'PATCH',
      path: `${AUTOMATIONS_API_BASE_V1}/${automationId}`,
    });
  }

  /**
   * Removes automation.
   *
   * @param {string} automationId The id of the automation to be removed.
   */
  public removeAutomation(automationId: string) {
    return ajaxSend<Response<AutomationT>>({
      method: 'DELETE',
      path: `${AUTOMATIONS_API_BASE_V1}/${automationId}`,
    });
  }
}

export const automationsApi = new AutomationsApi();
